// extracted by mini-css-extract-plugin
module.exports = {"fadeInFromBottom":"Animation_fadeInFromBottom__2l8gJ","fadeInFromBottomAnimation":"Animation_fadeInFromBottomAnimation__5s_lJ"};